import { render, staticRenderFns } from "./FailureReasons.vue?vue&type=template&id=342d030c"
import script from "./FailureReasons.vue?vue&type=script&lang=js"
export * from "./FailureReasons.vue?vue&type=script&lang=js"
import style0 from "./FailureReasons.vue?vue&type=style&index=0&id=342d030c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports